import React, { useState, useEffect } from "react";
import style from "./wabaDashboard.module.css";
import api from "../../services/api";
import CardData from "./CardData";

export default function WabaDashboard() {
  const [wabaData, setWabaData] = useState({});

  async function loadWabaData() {
    const endpoints = {
      "5min": "api/database/report/dashWabaMetrics5m",
      "30min": "api/database/report/dashWabaMetrics30m",
      "60min": "api/database/report/dashWabaMetrics60m",
      "24h": "api/database/report/dashWabaMetrics24h",
    };

    const results = await Promise.all(
      Object.entries(endpoints).map(async ([key, url]) => {
        const response = await api.get(url, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        return { key, data: response.data };
      })
    );

    const mapped = results.reduce((acc, item) => {
      acc[item.key] = { data: item.data };
      return acc;
    }, {});

    const normalizedData = await normalizeMetrics(mapped);

    setWabaData(normalizedData);
  }

  function normalizeMetrics(data) {
    const keys = Object.keys(data);
    let result = [];

    for (let i = 0; i < keys.length; i++) {
      if (!data[keys[i]].data.length) {
        result.push({
          name: keys[i],
          data: {
            Genesys: {
              MinDurationMS: 0,
              MaxDurationMS: 0,
              AvgDurationMS: 0,
            },
            Espresso: {
              MinDurationMS: 0,
              MaxDurationMS: 0,
              AvgDurationMS: 0,
            },
            Total: {
              MinDurationMS: 0,
              MaxDurationMS: 0,
              AvgDurationMS: 0,
            },
            Interactions: 0,
          },
        });
      } else {
        result.push({
          name: keys[i],
          data: {
            Genesys: {
              MinDurationMS: data[keys[i]].data[0].GenesysMinDurationMS,
              MaxDurationMS: data[keys[i]].data[0].GenesysMaxDurationMS,
              AvgDurationMS: data[keys[i]].data[0].GenesysAvgDurationMS,
            },
            Espresso: {
              MinDurationMS: data[keys[i]].data[0].EspressoMinDurationMS,
              MaxDurationMS: data[keys[i]].data[0].EspressoMaxDurationMS,
              AvgDurationMS: data[keys[i]].data[0].EspressoAvgDurationMS,
            },
            Total: {
              MinDurationMS: data[keys[i]].data[0].TotalMinDurationMS,
              MaxDurationMS: data[keys[i]].data[0].TotalMaxDurationMS,
              AvgDurationMS: data[keys[i]].data[0].TotalAvgDurationMS,
            },
            Interactions: data[keys[i]].data[0].Interactions,
          },
        });
      }
    }

    return result;
  }

  function translate(data) {
    switch (data) {
      case "5min":
        return "Métricas dos últimos 5 minutos";
      case "30min":
        return "Métrica dos últimos 30 minutos";
      case "60min":
        return "Métrica da última 1 hora";
      case "24h":
        return "Métrica das últimas 24 horas";
      default:
        return "";
    }
  }

  useEffect(() => {
    loadWabaData();
    const interval = setInterval(() => {
      loadWabaData();
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container">
      <div className="d-flex align-items-center justify-content-between me-4">
        <div className="titlePage">Métricas WABA</div>
      </div>
      <div className="body  me-4 mb-5">
        <div className={`${style.row}`}>
          {wabaData && wabaData.length
            ? wabaData.map((item) => (
                <div className={`${style.col6} mb-5 `}>
                  <div className={`${style.cardWaba}`}>
                    <h4 className="mb-0 titlePage"> {translate(item.name)}</h4>
                    <CardData key={item.name} data={item.data} />
                  </div>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
}
